import bigInt from "big-integer"
import state from '../../store/state'

export function resolveDpCasePageUrl(dpId) {
  return `${state.dpURL}cases/${dpId}` // todo(egor): move to config dp url
}

export function resolveCaseServicePageUrl(router, caseId) {
  let route = router.resolve({name: 'CaseServicesPage', params: {caseId: caseId}});
  return route.href
}

export function calculateExecutedPrice(item) {
  let sum = _.reduce(item.affectedServices.list, (acc, it) => {
    let price = bigInt(Math.round(it.itemPrice.amount * 100));
    let fullPrice = price.multiply(it.executedQty);
    return acc.add(fullPrice)
  }, bigInt(0));

  return {
    amount: Number(sum.toString()) / 100,
    currency: 'rub'
  };
}



// WEBPACK FOOTER //
// ./src/components/analytics/utils.js